"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.AuthProvider = exports.AuthContext = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/json/stringify"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _authClients = require("./authClients");

var AuthContext = /*#__PURE__*/_react.default.createContext({});

exports.AuthContext = AuthContext;

/**
 * @example
 * ```js
 *  const client = new Auth0Client(options)
 *  // ...
 *  <AuthProvider client={client} type="auth0" skipFetchCurrentUser={true}>
 *    {children}
 *  </AuthProvider>
 * ```
 */
// TODO: Determine what should be done when fetching the current user fails
var AuthProvider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AuthProvider, _React$Component);

  var _super = (0, _createSuper2.default)(AuthProvider);

  function AuthProvider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AuthProvider);
    _this = _super.call(this, props);
    _this.state = {
      loading: true,
      isAuthenticated: false,
      userMetadata: null,
      currentUser: null
    };
    _this.rwClient = void 0;
    _this.getCurrentUser = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var token, response, _data$redwood, _yield$response$json, data;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.props.skipFetchCurrentUser) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", undefined);

            case 2:
              _context.next = 4;
              return _this.rwClient.getToken();

            case 4:
              token = _context.sent;
              _context.next = 7;
              return window.fetch("".concat(window.__REDWOOD__API_PROXY_PATH, "/graphql"), {
                method: 'POST',
                headers: {
                  'content-type': 'application/json',
                  'auth-provider': _this.rwClient.type,
                  authorization: "Bearer ".concat(token)
                },
                body: (0, _stringify.default)({
                  query: 'query __REDWOOD__AUTH_GET_CURRENT_USER { redwood { currentUser } }'
                })
              });

            case 7:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 14;
                break;
              }

              _context.next = 11;
              return response.json();

            case 11:
              _yield$response$json = _context.sent;
              data = _yield$response$json.data;
              return _context.abrupt("return", data === null || data === void 0 ? void 0 : (_data$redwood = data.redwood) === null || _data$redwood === void 0 ? void 0 : _data$redwood.currentUser);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this.reauthenticate = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var userMetadata, isAuthenticated, currentUser;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.rwClient.getUserMetadata();

            case 2:
              userMetadata = _context2.sent;
              isAuthenticated = userMetadata !== null;
              currentUser = null;

              if (!isAuthenticated) {
                _context2.next = 9;
                break;
              }

              _context2.next = 8;
              return _this.getCurrentUser();

            case 8:
              currentUser = _context2.sent;

            case 9:
              _this.setState({
                userMetadata: userMetadata,
                currentUser: currentUser,
                isAuthenticated: isAuthenticated,
                loading: false
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this.logIn = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(options) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.rwClient.login(options);

              case 2:
                return _context3.abrupt("return", _this.reauthenticate());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.logOut = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(options) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.rwClient.logout(options);

              case 2:
                _this.setState({
                  userMetadata: null,
                  currentUser: null,
                  isAuthenticated: false
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.rwClient = (0, _authClients.createAuthClient)(props.client, props.type);
    return _this;
  }

  (0, _createClass2.default)(AuthProvider, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _this$rwClient$restor, _this$rwClient;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (_this$rwClient$restor = (_this$rwClient = this.rwClient).restoreAuthState) === null || _this$rwClient$restor === void 0 ? void 0 : _this$rwClient$restor.call(_this$rwClient);

              case 2:
                return _context5.abrupt("return", this.reauthenticate());

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          client = _this$props.client,
          type = _this$props.type,
          children = _this$props.children;
      return /*#__PURE__*/_react.default.createElement(AuthContext.Provider, {
        value: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.state), {}, {
          logIn: this.logIn,
          logOut: this.logOut,
          getToken: this.rwClient.getToken,
          getCurrentUser: this.getCurrentUser,
          reauthenticate: this.reauthenticate,
          client: client,
          type: type
        })
      }, children);
    }
  }]);
  return AuthProvider;
}(_react.default.Component);

exports.AuthProvider = AuthProvider;
AuthProvider.defaultProps = {
  skipFetchCurrentUser: false
};